import React, { useMemo } from "react";
import Highcharts from "highcharts/highmaps";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@mui/material";
import PeriodSelect from "./PeriodSelect";
import WidgetShell from "./WidgetShell";
import { applyEnterpriseChartTheme, HC_CONTAINER_PROPS } from "./chartTheme";
import { ExdGhostButton } from "./ExdControls";
import { ExdHint, chartWrapSx } from "./exdMui";

const ChartWidget = ({
  title,
  subtitle,
  infoTitle,
  loading,
  chartOptions,
  periodValue,
  onPeriodChange,
  periodFallback = "All",
  actionLabel,
  onAction,
  children,
  variant = "chart",
  summary,
  chartHeight,
  hint,
  sx,
}) => {
  const themedOptions = useMemo(() => {
    if (!chartOptions) return chartOptions;
    const themed = applyEnterpriseChartTheme(chartOptions);
    if (chartHeight && themed?.chart) {
      return {
        ...themed,
        chart: { ...themed.chart, height: chartHeight },
      };
    }
    return themed;
  }, [chartOptions, chartHeight]);

  return (
    <WidgetShell
      title={title}
      subtitle={subtitle}
      infoTitle={infoTitle}
      loading={loading}
      variant={variant}
      summary={summary}
      sx={sx}
      controls={
        <>
          {actionLabel && onAction ? (
            <ExdGhostButton onClick={onAction}>{actionLabel}</ExdGhostButton>
          ) : null}
          {onPeriodChange ? (
            <PeriodSelect
              value={periodValue}
              onChange={onPeriodChange}
              fallbackLabel={periodFallback}
            />
          ) : null}
        </>
      }
    >
      {children}
      {themedOptions ? (
        <Box sx={chartWrapSx(250)}>
          <HighchartsReact
            highcharts={Highcharts}
            options={themedOptions}
            containerProps={HC_CONTAINER_PROPS}
          />
        </Box>
      ) : null}
      {hint ? <ExdHint>{hint}</ExdHint> : null}
    </WidgetShell>
  );
};

export default ChartWidget;
